export default __webpack_public_path__ + "static/oxygen-fbf1cb768b1b0e00defa8350acc07a1c.svg";